import template from 'modules/main/templates/modals/serverErrorNotification.tmpl.html';
import {SIZE_MEDIUM} from '../../modules/common/modal/modal-service';

export default function ErrorInterceptorWrapper($httpProvider) {
    'ngInject';
    $httpProvider.interceptors.push(ErrorInterceptor);
}

export function ErrorInterceptor($q, $injector) {
    'ngInject';
    return {
        responseError: function(rejection) {
            let $uibModal;

            // If server responds with 5xx HTTP status
            if (/5\d{2}/.test(rejection.status) && !rejection.config.skipErrorInterceptor) {
                $uibModal = $injector.get('$uibModal');
                $uibModal.open({
                    template,
                    size: 'md',
                });
            }

            if (rejection.status === 400 && rejection.data && rejection.data.ErrorCode === 10062) {
                const modalService = $injector.get('modalService');
                const l10nService = $injector.get('l10nService');
                const popup = modalService.createInfoModal(l10nService.localize('Restrictions'), rejection.data.ErrorMessage, SIZE_MEDIUM);

                popup();
            }

            return $q.reject(rejection);
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/configs/interceptors/errorsInterceptor.js